export const ESCROW_STATUS = {
  PENDING:   'pending',
  ACTIVE:    'active',
  SUBMITTED: 'submitted',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const STATUS_COLORS = {
  pending:   '#e67e22',
  active:    '#2980b9',
  submitted: '#8e44ad',
  completed: '#27ae60',
  cancelled: '#7f8c8d',
};
